interface SyncStatusProps {
  lastSyncTime: string | null;
}

/** Displays data freshness indicator — "Data last synced: X ago" (FR-003). */
export default function SyncStatus({ lastSyncTime }: SyncStatusProps) {
  if (!lastSyncTime) {
    return (
      <span className="sync-status">
        <span className="sync-dot none" />
        No sync data available
      </span>
    );
  }

  const syncDate = new Date(lastSyncTime);
  const now = new Date();
  const diffMs = now.getTime() - syncDate.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  let agoText: string;
  if (diffMins < 1) agoText = 'just now';
  else if (diffMins < 60) agoText = `${diffMins} minute${diffMins !== 1 ? 's' : ''} ago`;
  else if (diffHours < 24) agoText = `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
  else agoText = `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;

  const isStale = diffHours > 24;

  return (
    <span className="sync-status">
      <span className={`sync-dot ${isStale ? 'stale' : ''}`} />
      Data last synced: {agoText}
    </span>
  );
}
